<div class="contact-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div class="btn btn-hover bg-secondary-color">Contact Us</div>
      <div class="big-caption text-default-color">Get closer with us</div>
      <p style="text-align: center">
        Reach out to us through any means below and we will get back to you
        shortly
      </p>
    </div>
  </div>

  <!-- contact us card session -->
  <div class="cont-card">
    <div
      class="card"
      data-aos="zoom-in"
      data-aos-duration="2000"
    >
      <form
        class="form d-flexbox col justify-content-left align-items-top"
        [formGroup]="contactUsForm"
        (ngSubmit)="submit()"
      >
        <div class="input">
          <div class="input1">
            <label for="firstName" class="caption-primary-color"
              >First Name <span class="danger">*</span></label
            >
            <input
              type="text"
              formControlName="firstName"
              placeholder="first Name"
            />
            <div
              *ngIf="
                contactUsForm.get('firstName').invalid &&
                contactUsForm.get('firstName').touched
              "
            >
              <small
                *ngIf="
                  contactUsForm.get('firstName').invalid &&
                  contactUsForm.get('firstName').touched
                "
                class="danger"
              >
                *First name is required</small
              >
            </div>
          </div>
          <div class="input1">
            <label for="lastName" class="caption-primary-color"
              >Last Name <span class="danger">*</span></label
            >
            <input
              type="text"
              formControlName="lastName"
              placeholder="last Name"
            />
            <div
              *ngIf="
                contactUsForm.get('lastName').invalid &&
                contactUsForm.get('lastName').touched
              "
            >
              <small
                *ngIf="
                  contactUsForm.get('lastName').invalid &&
                  contactUsForm.get('lastName').touched
                "
                class="danger"
              >
                *Last name is required</small
              >
            </div>
          </div>
        </div>
        <div class="input">
          <div class="input1">
            <label for="email" class="caption-primary-color">Email <span class="danger">*</span></label>
            <input
              type="email"
              formControlName="email"
              placeholder="email"
              required
            />
            <div
              *ngIf="
                contactUsForm.get('email').invalid &&
                contactUsForm.get('email').touched
              "
            >
              <small
                *ngIf="
                  contactUsForm.get('email').invalid &&
                  contactUsForm.get('email').touched
                "
               class="danger"
              >
                *Your email is required</small
              >
            </div>
          </div>
          <div class="input1">
            <label for="issues" class="caption-primary-color"
              >Select Issues <span class="danger">*</span></label
            >
            <select formControlName="subject" id="issues">
              <option value="">-- --</option>
              <option value="Enquiry on pos Activation">
                Enquiry on POS Activation
              </option>
              <option value="Enquiry on Payslate">Enquiry on Payslate</option>
              <option value="Enquiry on payment Gateway">
                Enquiry on Payment Gateway
              </option>
              <option value="Training">
                Training
              </option>
            </select>
            <div
              *ngIf="
                contactUsForm.get('subject').invalid &&
                contactUsForm.get('subject').touched
              "
            >
              <small
                *ngIf="
                  contactUsForm.get('subject').invalid &&
                  contactUsForm.get('subject').touched
                "
                class="danger"
              >
                *Subject is required</small
              >
            </div>
          </div>
        </div>
        <div class="input">
          <div class="input1">
            <label for="tellUsMore">Message <span class="danger">*</span></label>
            <textarea
              formControlName="message"
              id=""
              cols="60"
              rows="10"
              placeholder="Leave a message"
            ></textarea>

            <div
              *ngIf="
                contactUsForm.get('message').invalid &&
                contactUsForm.get('message').touched
              "
            >
              <small
                *ngIf="
                  contactUsForm.get('message').invalid &&
                  contactUsForm.get('message').touched
                "
               class="danger"
              >
                *Message is required</small
              >
            </div>
          </div>
        </div>
        <!-- <div class="input2">
          <input type="radio" name="" id="" />
          <p>
            I agree to the <span style="color: #045a7d">Terms and Policy</span>
          </p>
        </div> -->

        <!-- other options for the formsubmit.co -->
        <!-- <input type="hidden" name="_captcha" value="false"> -->
        <!-- This value is used for the email's subject, so that you can quickly reply to submissions without having to edit the subject line each time. -->
        <!-- <input type="hidden" name="_subject" value="New HuiosPay Customer In touch!"> -->

        <!-- If you want to CC multiple email addresses, then just make it a list of email addresses separate by commas. -->
        <!-- <input type="hidden" name="_cc" value="hello@huiospay.com,dickson@huiospay.com,sdafe@huiospay.com,francis.awe@huiospay.com,john.m@huiospay.com"> -->
        <!-- <input type="hidden" name="_autoresponse" value="Thanks for contacting Huiospay. Our representative we contact you shortly."> -->
        <!-- By default, after submitting a form the user is shown the FormSubmit "Thank You" page. You can provide an alternative URL for "Thank You" page. -->
        <!-- <input type="hidden" name="_next" value="https://huiospay.com"> -->

        <!-- <div> -->
        <input type="submit" value="Send Message" />
        <p class="text-tertiary-color"><span class="danger">*</span> These fields are required</p>
        <!-- </div> -->
      </form>

      <div class="get-address">
        <div class="address">
          <div>
            <app-font-icon
              iconType="remix"
              iconName="map-pin-line"
              iconSize="custom"
              iconColor="#045A7D"
            >
            </app-font-icon>
            Address:
          </div>
          <p>1st floor, AP Plaza, 28 Adetokunbo Ademola Cresent Wuse 2, Abuja</p>
          <!-- <p>Plot 86, Cadastral Zone B06,Mabushi District, Abuja</p> -->
        </div>
        <div class="phone">
          <div>
            <app-font-icon
              iconType="remix"
              iconName="phone-line"
              iconSize="custom"
              iconColor="#045A7D"
            >
            </app-font-icon>
            Phone Number:
          </div>
          <p><a href="tel:08037086670">08037086670</a></p>
        </div>
        <div class="email">
          <div>
            <app-font-icon
              iconType="remix"
              iconName="mail-check-line"
              iconSize="custom"
              iconColor="#045A7D"
            >
            </app-font-icon>
            Email:
          </div>
          <p><a href="mailto:contactus@huiospay.com">contactus@huiospay.com</a></p>
        </div>
      </div>
    </div>
  </div>
  <!--end of contact us card session -->

  <app-map-section></app-map-section>

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

  <app-back-to-top
    [acceleration]="2"
    [animate]="true"
    [scrollDistance]="50"
    [speed]="50"
  >
  </app-back-to-top>
</div>
